<section class="wizard-panel">
  <div class="wizard-intro">
    <h2>Review &amp; Confirm</h2>
    <p>Everything you told us, in one place.</p>
  </div>

  <div class="wizard-columns">
    <lib-card cardTitle="Business Information">
      <lib-card-row
        label="Business Name"
        [value]="business()?.businessName"
      />
      <lib-card-row
        label="Business Type"
        [value]="businessType()"
      />
      <lib-card-row
        label="Contractors License Number"
        [value]="business()?.contractorLicenseNumber"
      />
    </lib-card>

    <lib-card cardTitle="Addresses">
      <div class="addresses">
        <lib-address [lines]="primaryLines()" chipText="Primary" />
        <lib-address [lines]="mailingLines()" chipText="Mailing" chipType="secondary" />
      </div>
    </lib-card>
  </div>

  <lib-card cardTitle="Operations">
    <div class="description">
      <p class="bold">Description of Operations</p>
      <p>{{ answers().descriptionOfOperations }}</p>
    </div>
    @for (work of answers().typeOfWorkPercentages; track work.typeOfWork; let i = $index) {
      <lib-card-row
        [label]="work.typeOfWork ?? ''"
        [value]="legacy() ? (work.payroll | currency: 'USD' : 'symbol' : '1.0-0') : percentText(work.percentage)"
      />
    }
    <lib-card-row
      label="Estimated Annual Gross Receipts"
      [value]="answers().grossReceipts | currency: 'USD' : 'symbol' : '1.0-0'"
    />
    @if (answers().annualPayroll != null) {
      <lib-card-row
        [label]="payrollLabel()"
        [value]="answers().annualPayroll | currency: 'USD' : 'symbol' : '1.0-0'"
      />
    }
    <lib-card-row
      label="Estimated Annual Subcontractor Costs"
      [value]="answers().subcontractedCosts | currency: 'USD' : 'symbol' : '1.0-0'"
    />
    @if (!legacy()) {
      <lib-card-row
        label="Owners Active in the Field"
        [value]="answers().numberOfOwnersInField"
      />
    }
    <lib-card-row
      label="Number of Employees"
      [value]="answers().numberOfEmployees"
    />
    <lib-card-row
      label="Multi-unit Residential New Construction"
      [value]="yesNo(answers().performNewConstruction)"
    />
    <lib-card-row label="Casual / Day Labor Used" [value]="yesNo(answers().usesDayLabor)" />
  </lib-card>

  <lib-card cardTitle="Policy Eligibility">
    @for (title of eligibilityTitles(); track $index) {
      <lib-card-row [label]="title" [value]="wizard().eligibilityReviewed ? 'Reviewed' : 'Not reviewed'" />
    }
  </lib-card>


  <button
    type="button"
    class="decision"
    [class.selected]="everythingCorrect()"
    [attr.aria-pressed]="everythingCorrect()"
    (click)="toggleCorrect()"
  >
    <span class="check"><lib-icons icon="check" /></span>
    <span>
      <span class="decision-title">Everything is Correct</span>
      <span class="decision-text">I’ve reviewed every section above</span>
    </span>
  </button>

  @if (everythingCorrect()) {
    <lib-card cardTitle="Disclaimer">
      <p class="notice">
        Responses submitted through this inspection are provided to your insurance carrier and become part of
        your policy record. Submitting this inspection does not itself amend your policy; any change to
        coverage, rate or premium is made by endorsement issued by the carrier.
      </p>
    </lib-card>

    <lib-card cardTitle="Fraud Warning">
      <p class="notice">
        Any person who knowingly and with intent to defraud any insurance company or other person files an
        application for insurance or statement of claim containing any materially false information, or
        conceals for the purpose of misleading information concerning any fact material thereto, commits a
        fraudulent insurance act, which is a crime and subjects such person to criminal and civil penalties.
        The undersigned is an authorized representative of the applicant and represents that reasonable
        enquiry has been made to obtain the answers to questions on this application. He/she represents that
        the answers are true, correct and complete to the best of his/her knowledge.
      </p>
    </lib-card>

    <mat-checkbox [checked]="responsesConfirmedTrue()" (change)="responsesConfirmedTrue.set($event.checked)">
      I, <span class="bold">{{ contactName() }},</span> confirm that the responses in this inspection are true,
      correct and complete, and that I am authorized to submit them on behalf of the insured.
    </mat-checkbox>
  }
</section>

<div class="wizard-footer">
  <div class="submit">
    <lib-buttons
      size="small"
      text="Accept &amp; Submit"
      [disabled]="!everythingCorrect() || !responsesConfirmedTrue()"
      (click)="submit.emit()"
    />
  </div>
</div>
